import React from "react";
import { useTranslation } from "react-i18next";
import { DataTable, useSortableColumns } from "./DashboardStyles";

type School = {
  school_name: string;
  school_link: string;
  student_profile_cnt: number;
  time_spent_hours: number;
  tutoring_value_dollars: number;
  lessons_completed_cnt: number;
};

type SortKey = keyof Omit<School, "school_link">;

export const SchoolsTable = ({
  schools,
  navigate,
}: {
  schools: School[];
  navigate: (string) => void;
}) => {
  const { t } = useTranslation();
  const { thProps, indicator, sortRows } = useSortableColumns<SortKey>();

  const sorted = sortRows(schools, (a, b, key) => {
    const av = a[key];
    const bv = b[key];
    return typeof av === "number"
      ? av - (bv as number)
      : String(av).localeCompare(String(bv));
  });

  return (
    <DataTable>
      <thead>
        <tr>
          <th {...thProps("school_name")}>
            {t("school_list_school")}
            {indicator("school_name")}
          </th>
          <th {...thProps("student_profile_cnt")}>
            {t("dashboard_active_users")}
            {indicator("student_profile_cnt")}
          </th>
          <th {...thProps("lessons_completed_cnt")}>
            {t("dashboard_lessons_completed")}
            {indicator("lessons_completed_cnt")}
          </th>
          <th {...thProps("time_spent_hours")}>
            {t("dashboard_time_spent_learning")}
            {indicator("time_spent_hours")}
          </th>
          <th {...thProps("tutoring_value_dollars")}>
            {t("dashboard_tutoring_value")}
            {indicator("tutoring_value_dollars")}
          </th>
        </tr>
      </thead>
      <tbody>
        {sorted.map((school, index) => (
          <tr key={index}>
            <td>
              <a
                href={school.school_link}
                onClick={() => navigate(school.school_link)}
              >
                {school.school_name}
              </a>
            </td>
            <td>{t("intcomma", { val: school.student_profile_cnt })}</td>
            <td>{t("intcomma", { val: school.lessons_completed_cnt })}</td>
            <td>{t("intcomma", { val: school.time_spent_hours })} hours</td>
            <td>${t("intcomma", { val: school.tutoring_value_dollars })}</td>
          </tr>
        ))}
      </tbody>
    </DataTable>
  );
};
